export const SEND_EMAIL_WELCOME = 'SEND_EMAIL_WELCOME';
export const SEND_EMAIL_WELCOME_FULFILLED = 'SEND_EMAIL_WELCOME_FULFILLED';
export const SEND_EMAIL_WELCOME_REJECTED = 'SEND_EMAIL_WELCOME_REJECTED';

export const SEND_EMAIL_DOCUMENTATION = 'SEND_EMAIL_DOCUMENTATION';
export const SEND_EMAIL_DOCUMENTATION_FULFILLED = 'SEND_EMAIL_DOCUMENTATION_FULFILLED';
export const SEND_EMAIL_DOCUMENTATION_REJECTED = 'SEND_EMAIL_DOCUMENTATION_REJECTED';
